// src/components/CurrencyInput.tsx
// ─────────────────────────────────────────────────────────────────────────────
// Shared currency input with comma formatting on blur.
// On focus: raw number for editing.  On blur: comma-formatted display.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import { useCommaInput } from '../utils/useCommaInput';

interface CurrencyInputProps {
  label: string;
  value: number;
  onChange: (v: number) => void;
  note?: string;
  placeholder?: string;
  /** Extra classes on the outer wrapper */
  className?: string;
}

export default function CurrencyInput({
  label, value, onChange, note, placeholder = '0', className = '',
}: CurrencyInputProps) {
  const inputProps = useCommaInput(value, onChange);

  return (
    <div className={className}>
      <label className="text-xs text-gray-400 uppercase tracking-wide font-medium">{label}</label>
      <div className="flex items-center mt-1 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 focus-within:ring-2 focus-within:ring-ma-navy/20 focus-within:border-ma-navy/40">
        <span className="text-gray-400 text-sm mr-2">£</span>
        <input
          {...inputProps}
          min={0}
          placeholder={placeholder}
          className="flex-1 bg-transparent text-base font-bold text-ma-navy outline-none"
        />
      </div>
      {note && <p className="text-xs text-gray-400 mt-0.5">{note}</p>}
    </div>
  );
}
